import { BaseApiModel } from 'app/models/api/response';

export enum SensitivePhraseType {
    moderate = 'moderate',
    severe = 'severe',
}

export enum SensitivePhraseTarget {
    aboutChatAndEmail = 'about,chat&email',
    address = 'address',
    firstNameAndLastName = 'firstName&lastName',
}

export class SensitivePhraseMeta {
    rowCount?: number;
    page?: number;
    pageCount?: number;
}

export function getSensitivePhraseTargetName(target: SensitivePhraseTarget) {
    switch (target) {
        case SensitivePhraseTarget.aboutChatAndEmail:
            return 'About, chat and email';
        case SensitivePhraseTarget.address:
            return 'Address';
        case SensitivePhraseTarget.firstNameAndLastName:
            return 'First and last name';
    }
}

export class SensitivePhrase extends BaseApiModel {
    phrase?: string;
    type = SensitivePhraseType.moderate;
    target = SensitivePhraseTarget.aboutChatAndEmail;
    updatedAt = '';

    get targetName() {
        return getSensitivePhraseTargetName(this.target);
    }

    get isModerate() {
        return this.type === SensitivePhraseType.moderate;
    }

    get isSevere() {
        return this.type === SensitivePhraseType.severe;
    }
}
